module.exports = __webpack_public_path__ + "img/shipment-tracking.695ed529.png";